module.exports = __webpack_public_path__ + "0af5d249/img/link-icon.fa09ed66.svg";